/* Lunelle - cadeaux du panier. Trois mecaniques dans un seul script, parce qu'il
   observe deja le tiroir et le panier :
     1. le porte-monnaie offert des 69 EUR (snippet lunelle-gift-progress)
     2. l'attache-gourde offert qui doit accompagner La Spacieuse
     3. l'ordre des lignes du tiroir : sacs -> carte "2e sac offert" -> gourde

   ORDRE DES LIGNES (2026-08-14). La carte verte tombait sous la gourde, donc
   hors ecran : mesure sur iPhone 375x812, la carte commencait a 437 alors que la
   zone de defilement s'arrete a 555, soit 161 px caches, exactement les pastilles
   de couleur. En la remontant juste sous le sac elle court de 281 a 560, il ne
   manque que ~5 px. On ne la met PAS tout en haut : la cliente doit d'abord voir
   le sac qu'elle vient d'ajouter (demande explicite).
   Contrainte : les lignes sont un vrai tableau (tbody > tr.cart-item), un <div>
   ne peut pas s'inserer entre deux <tr>. D'ou une vraie ligne tr.lunelle-bogo-slot
   creee par reorderCartRows(), stylee dans lunelle-cart-boot.
   Les lignes sont identifiees par data-quantity-variant-id resolu via cart.js, et
   PAS par l'URL produit : le porte-monnaie a pour handle
   "attache-gourde-avec-mousqueton-copy", une comparaison sur "attache-gourde"
   l'attraperait aussi.

   CORRECTIF 2026-08-14 : LES DEUX SACS DOIVENT ETRE GROUPES EN TETE. Deux bugs,
   tous deux corriges dans reorderCartRows :
     a) la fonction commencait par `if (!bogo) return`. Or la carte verte ne
        s'affiche que sur une quantite IMPAIRE de sacs : avec 2 sacs elle
        n'existe pas, donc on sortait avant de reordonner quoi que ce soit et la
        gourde restait coincee ENTRE les deux sacs (constate par la cliente).
     b) meme quand elle tournait, elle ne retenait que `lastBag` et ne groupait
        jamais plusieurs lignes de sac ensemble.
   Desormais : tous les sacs remontent en tete dans leur ordre relatif actuel
   (donc le sac paye reste avant le sac offert), PUIS la carte verte si elle
   existe, PUIS la gourde. La carte verte reste sous le dernier sac, jamais en
   haut, conformement a la demande d'origine.

   ATTACHE-GOURDE. Kaching ne l'ajoute que depuis la fiche produit ou son bloc est
   installe. Mesure : ajout depuis la fiche -> sac + 2e sac + gourde ; ajout depuis
   le produit en vedette de l'ACCUEIL -> 1 seule ligne. On garantit donc la gourde
   cote theme, quel que soit le chemin d'ajout. Elle est gratuite par une remise
   automatique 100 % SANS minimum. Jamais de doublon : si Kaching a deja mis la
   sienne, on ne touche a rien. On ne retire que la NOTRE (propriete
   _gourde_offerte). Si la cliente la supprime, on ne la remet pas : memorise pour
   la session, sinon le panier se battrait avec elle.

   LIGNE CADEAU vs PRODUIT ACHETE : on ne touche QUE les lignes portant notre
   propriete. Un porte-monnaie ajoute volontairement est un achat normal. En
   revanche AUCUNE ligne de porte-monnaie ne compte dans le montant qualifiant,
   pour rester aligne sur la remise BXGY qui exclut ce produit de son "buys".

   GARDE-FOUS ANTI-BLOCAGE :
     1. L'observer ecoute childList uniquement, PAS characterData.
     2. resize passe par requestAnimationFrame : hoist() force un recalcul.
     3. refreshDrawer() de fond est coalesce : un seul rendu de section en vol.
     4. Toute ecriture panier passe par `busy` ; l'ajout de la gourde a un
        compteur d'echecs (3 max) au lieu de boucler.
     5. hoist() et reorderCartRows() ne bougent rien s'ils sont deja en place :
        le cycle observer -> deplacement -> observer converge en un tour. */
(function () {
  if (window.__lunelleGiftBound) return;
  window.__lunelleGiftBound = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;
  var timer = null;
  var drawerPending = null;
  var resizeQueued = false;

  var BAG_PID = 8975884747011;          /* Lunelle - La Spacieuse */
  var GOURDE_PID = 9014185918723;       /* Attache-gourde avec mousqueton */
  var GOURDE_VARIANT = 46934800433411;
  var GOURDE_PROP = '_gourde_offerte';
  var gourdeTries = 0;

  /* Palier 2 : carte cadeau 15 EUR offerte des 78 EUR, produit a 0 EUR ajoute
     automatiquement UNIQUEMENT quand le porte-monnaie (palier 1) est deja pris. */
  var CARD_PID = 9608723923203;         /* Carte cadeau 15 EUR */
  var CARD_VARIANT = 49509604131075;
  var CARD_THRESHOLD = 7800;            /* montant paye, comme le porte-monnaie */
  var CARD_PROP = '_carte_cadeau';

  function nodes() { return document.querySelectorAll('[data-lunelle-gift]'); }

  function config() {
    var n = nodes()[0];
    if (!n) return null;
    return {
      threshold: Number(n.getAttribute('data-threshold')),
      pid: Number(n.getAttribute('data-gift-pid')),
      bagPid: Number(n.getAttribute('data-bag-pid')) || BAG_PID
    };
  }

  function flag(k) { try { return sessionStorage.getItem('lunelle_' + k); } catch (e) { return null; } }
  function setFlag(k, v) { try { sessionStorage.setItem('lunelle_' + k, v); } catch (e) {} }

  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + '€'; }
  function moneyDrawer(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(path, payload) {
    return fetch(ROOT + path, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error(path); return r.json(); });
  }

  function unstick(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !cart || !cart.item_count) return;
    if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
  }

  /* sacs -> carte "2e sac offert" -> gourde. Idempotent : si tout est deja en
     place, aucun noeud n'est deplace, donc l'observer ne se rearme pas. */
  function reorderCartRows(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var firstRow = drawer.querySelector('.cart-item');
    if (!firstRow || !firstRow.parentElement) return;
    var body = firstRow.parentElement;
    var slot = body.querySelector('.lunelle-bogo-slot');
    var bogo = drawer.querySelector('[data-lunelle-bogo]');

    var vp = {};
    (cart.items || []).forEach(function (i) { vp[String(i.variant_id)] = i.product_id; });

    function pidOf(row) {
      var q = row.querySelector('[data-quantity-variant-id]');
      return q ? vp[q.getAttribute('data-quantity-variant-id')] : undefined;
    }

    var bagRows = [];
    var gourdeRows = [];
    [].slice.call(body.querySelectorAll('.cart-item')).forEach(function (r) {
      var p = pidOf(r);
      if (p === BAG_PID) bagRows.push(r);
      else if (p === GOURDE_PID) gourdeRows.push(r);
    });

    /* 1. Tous les sacs en tete, dans leur ordre relatif actuel : le sac paye
          reste donc avant le sac offert, ce qui raconte le prix dans le bon
          sens (59,99 EUR puis 0,00 EUR). */
    var anchor = null;
    bagRows.forEach(function (b) {
      var want = anchor ? anchor.nextElementSibling : body.firstElementChild;
      if (want !== b) body.insertBefore(b, want);
      anchor = b;
    });

    /* 2. La carte verte juste sous le DERNIER sac, si elle est rendue. Sans elle
          on retire la ligne technique, mais surtout on ne sort PAS de la
          fonction : le groupement des sacs ci-dessus doit avoir lieu meme sur un
          nombre pair de sacs, cas ou la carte n'existe jamais. */
    if (!bogo || !bagRows.length) {
      if (slot && slot.parentNode) slot.parentNode.removeChild(slot);
      slot = null;
    } else {
      if (!slot) {
        slot = document.createElement('tr');
        slot.className = 'lunelle-bogo-slot';
        slot.appendChild(document.createElement('td')).setAttribute('colspan', '99');
      }
      if (anchor.nextElementSibling !== slot) body.insertBefore(slot, anchor.nextElementSibling);
      var cell = slot.firstElementChild;
      if (bogo.parentElement !== cell) cell.appendChild(bogo);
      anchor = slot;
    }

    /* 3. La gourde ensuite. Sans aucun sac il n'y a rien a ancrer. */
    if (!anchor) return;
    gourdeRows.forEach(function (g) {
      if (anchor.nextElementSibling !== g) body.insertBefore(g, anchor.nextElementSibling);
      anchor = g;
    });
  }

  function ensureGourde(cart) {
    if (busy) return null;
    var bagQty = 0, gourdeUnits = 0, oursKey = null;
    (cart.items || []).forEach(function (i) {
      if (i.product_id === BAG_PID) bagQty += i.quantity;
      if (i.product_id === GOURDE_PID) {
        gourdeUnits += i.quantity;
        if (i.properties && i.properties[GOURDE_PROP]) oursKey = i.key;
      }
    });

    if (bagQty > 0 && gourdeUnits === 0) {
      if (flag('gourde_added') === '1') { setFlag('gourde_dismissed', '1'); return null; }
      if (flag('gourde_dismissed') === '1' || gourdeTries >= 3) return null;
      gourdeTries++;
      busy = true;
      var props = {};
      props[GOURDE_PROP] = 'oui';
      return post('cart/add.js', { items: [{ id: GOURDE_VARIANT, quantity: 1, properties: props }] })
        .then(function () { setFlag('gourde_added', '1'); return refreshDrawer(false); })
        .then(function () { busy = false; })
        .catch(function () { busy = false; });
    }

    if (bagQty === 0 && oursKey) {
      busy = true;
      setFlag('gourde_added', '');
      return post('cart/change.js', { id: oursKey, quantity: 0 })
        .then(function () { return refreshDrawer(false); })
        .then(function () { busy = false; })
        .catch(function () { busy = false; });
    }

    if (gourdeUnits > 0) setFlag('gourde_added', '1');
    return null;
  }

  function align(gift, items) {
    var cs = getComputedStyle(items);
    var bar = Math.max(0, items.offsetWidth - items.clientWidth);
    var left = cs.paddingLeft;
    var right = ((parseFloat(cs.paddingRight) || 0) + bar) + 'px';
    if (gift.style.marginLeft !== left) gift.style.marginLeft = left;
    if (gift.style.marginRight !== right) gift.style.marginRight = right;
  }

  /* Remonte TOUS les bandeaux compacts juste au-dessus de la liste du tiroir,
     porte-monnaie (palier 1) puis carte cadeau (palier 2). Idempotent : s'ils
     sont deja dans cet ordre juste avant la liste, on ne bouge rien, sinon
     l'observer se rearmerait en boucle. */
  function hoist() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var items = drawer.querySelector('.cart-drawer-items, cart-drawer-items');
    if (!items || !items.parentNode) return;
    var parent = items.parentNode;
    var gifts = [].slice.call(drawer.querySelectorAll('[data-gift-compact]')).filter(function (g) { return !g.contains(items); });
    if (!gifts.length) return;
    gifts.sort(function (a, b) {
      var ca = a.hasAttribute('data-lunelle-giftcard') ? 1 : 0;
      var cb = b.hasAttribute('data-lunelle-giftcard') ? 1 : 0;
      return ca - cb;
    });
    var arranged = true, ref = items;
    for (var i = gifts.length - 1; i >= 0; i--) {
      ref = ref.previousElementSibling;
      if (ref !== gifts[i]) { arranged = false; break; }
    }
    if (!arranged) gifts.forEach(function (g) { parent.insertBefore(g, items); });
    gifts.forEach(function (g) { align(g, items); });
  }

  function fillTotals(cart) {
    var sub = document.querySelector('.drawer__subtotal--amount');
    var sav = document.querySelector('.drawer__savings--amount');
    if (sub && /\.\.\./.test(sub.textContent)) sub.textContent = moneyDrawer(cart.original_total_price);
    if (sav && /\.\.\./.test(sav.textContent)) sav.textContent = (cart.total_discount > 0 ? '-' : '') + moneyDrawer(cart.total_discount);
  }

  function selectSwatch(sw) {
    var root = sw.closest('[data-lunelle-gift]');
    var picker = sw.closest('[data-gift-picker]');
    if (!picker || !root) return;
    picker.setAttribute('data-variant-id', sw.getAttribute('data-variant-id'));
    picker.querySelectorAll('[data-gift-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
    sw.classList.add('is-selected');

    var name = root.querySelector('[data-gift-colorname]');
    if (name) name.textContent = sw.getAttribute('data-color');
    var thumb = root.querySelector('[data-gift-thumb]');
    var img = sw.getAttribute('data-img');
    if (thumb && img) thumb.style.backgroundImage = "url('" + img + "')";
  }

  function applyMatch(colors) {
    nodes().forEach(function (n) {
      var all = [].slice.call(n.querySelectorAll('[data-gift-swatch]'));
      if (!all.length) return;
      var shown = all.filter(function (s) {
        return !colors.length || colors.indexOf(s.getAttribute('data-color')) !== -1;
      });
      var fallback = shown.length === 0;
      if (fallback) shown = all;

      all.forEach(function (s) { s.hidden = shown.indexOf(s) === -1; });

      var picker = n.querySelector('[data-gift-picker]');
      if (picker) {
        var current = picker.getAttribute('data-variant-id');
        var ok = shown.some(function (s) { return s.getAttribute('data-variant-id') === current; });
        if (!ok) selectSwatch(shown[0]);
      }

      var label = n.querySelector('[data-gift-label]');
      if (label) {
        label.textContent = (colors.length && !fallback)
          ? (shown.length > 1 ? 'Assorti à vos sacs' : 'Assorti à votre sac')
          : 'Choisissez votre couleur';
      }
    });
  }

  function paint(state, pct, remaining, claimed, isEmpty) {
    nodes().forEach(function (n) {
      n.setAttribute('data-state', state);

      /* Panier vide : le titre passe de "Plus que X EUR pour ce cadeau" a
         "Cadeau offert a partir de 69 euros d'achat", et la pastille "Encore X"
         disparait. Voir lunelle-gift-progress pour la copie et le CSS.
         C'est un ATTRIBUT et non un 4e data-state : lunelle-gift-thumb.js teste
         data-state === 'locked' pour animer la vignette, un etat 'empty' aurait
         donc fige le defile des coloris sur un panier vide. */
      if (isEmpty) n.setAttribute('data-gift-empty', '');
      else n.removeAttribute('data-gift-empty');

      var fill = n.querySelector('[data-gift-fill]');
      if (fill) fill.style.width = pct + '%';
      var track = n.querySelector('[data-gift-track]');
      if (track) track.setAttribute('aria-valuenow', String(pct));
      n.querySelectorAll('[data-gift-remaining]').forEach(function (el) { el.textContent = money(remaining); });

      if (claimed) {
        var name = n.querySelector('[data-gift-colorname]');
        if (name && claimed.color) name.textContent = claimed.color;
        var thumb = n.querySelector('[data-gift-thumb]');
        if (thumb && claimed.img) thumb.style.backgroundImage = "url('" + claimed.img + "')";
      }
    });
    hoist();
  }

  /* Palier 2 : peint les bandeaux carte cadeau. data-state = hidden tant que le
     porte-monnaie n'est pas pris, ce qui masque tout le module (voir le CSS de
     lunelle-giftcard-progress). */
  function paintCard(walletClaimed, inCart, qualifying, threshold) {
    var remaining = Math.max(0, threshold - qualifying);
    var pct = Math.max(0, Math.min(100, Math.round((qualifying / threshold) * 100)));
    var state = !walletClaimed ? 'hidden' : (inCart ? 'claimed' : (remaining === 0 ? 'unlocked' : 'locked'));
    document.querySelectorAll('[data-lunelle-giftcard]').forEach(function (n) {
      n.setAttribute('data-state', state);
      var fill = n.querySelector('[data-giftcard-fill]');
      if (fill) fill.style.width = pct + '%';
      var track = n.querySelector('[data-giftcard-track]');
      if (track) track.setAttribute('aria-valuenow', String(pct));
      n.querySelectorAll('[data-giftcard-remaining]').forEach(function (el) { el.textContent = money(remaining); });
    });
    hoist();
  }

  function chain(keysToDrop, firstKey) {
    var p = Promise.resolve();
    keysToDrop.forEach(function (k) {
      p = p.then(function () { return post('cart/change.js', { id: k, quantity: 0 }); });
    });
    if (firstKey) p = p.then(function () { return post('cart/change.js', { id: firstKey, quantity: 1 }); });
    return p;
  }

  function refresh() {
    return getCart().then(function (cart) {
      unstick(cart);
      fillTotals(cart);

      var acted = ensureGourde(cart);
      if (acted) return acted;

      /* Toujours, meme si le bandeau cadeau n'est pas rendu. */
      reorderCartRows(cart);

      var cfg = config();
      if (!cfg) return;

      var walletTotal = 0;
      var giftKeys = [];
      var giftUnits = 0;
      var claimed = null;
      var colors = [];

      (cart.items || []).forEach(function (i) {
        if (i.product_id === cfg.pid) {
          walletTotal += i.final_line_price;
          if (i.properties && i.properties._cadeau) {
            giftKeys.push(i.key);
            giftUnits += i.quantity;
            if (!claimed) claimed = { color: i.variant_title || '', img: i.image || '' };
          }
        } else if (i.product_id === cfg.bagPid && i.variant_title && colors.indexOf(i.variant_title) === -1) {
          colors.push(i.variant_title);
        }
      });

      var qualifying = Math.max(0, cart.total_price - walletTotal);
      var remaining = Math.max(0, cfg.threshold - qualifying);
      var pct = Math.max(0, Math.min(100, Math.round((qualifying / cfg.threshold) * 100)));

      if (giftKeys.length && qualifying < cfg.threshold && !busy) {
        busy = true;
        return chain(giftKeys, null)
          .then(function () { return refreshDrawer(false); })
          .then(function () { busy = false; })
          .catch(function () { busy = false; });
      }

      if (giftUnits > 1 && !busy) {
        busy = true;
        return chain(giftKeys.slice(1), giftKeys[0])
          .then(function () { return refreshDrawer(false); })
          .then(function () { busy = false; })
          .catch(function () { busy = false; });
      }

      /* Rien qui compte encore vers le seuil : panier vide, ou ne contenant que
         des lignes a 0 EUR comme la gourde offerte. Dans les deux cas "plus que
         69 EUR" serait faux, on annonce l'offre a la place. */
      var isEmpty = !giftKeys.length && remaining > 0 && qualifying === 0;

      applyMatch(colors);
      paint(giftKeys.length ? 'claimed' : (remaining === 0 ? 'unlocked' : 'locked'), pct, remaining, claimed, isEmpty);

      /* ---- Palier 2 : carte cadeau, conditionnee au porte-monnaie deja pris ---- */
      var cardWalletClaimed = giftKeys.length > 0;
      var cardKey = null, cardUnits = 0, cardLineTotal = 0;
      (cart.items || []).forEach(function (i) {
        if (i.product_id === CARD_PID && i.properties && i.properties[CARD_PROP]) {
          cardKey = i.key; cardUnits += i.quantity; cardLineTotal += i.final_line_price;
        }
      });
      var cardQualifying = Math.max(0, cart.total_price - walletTotal - cardLineTotal);

      if (cardWalletClaimed && cardQualifying >= CARD_THRESHOLD && !cardKey && !busy) {
        busy = true;
        var cardProps = {}; cardProps[CARD_PROP] = 'oui';
        return post('cart/add.js', { items: [{ id: CARD_VARIANT, quantity: 1, properties: cardProps }] })
          .then(function () { return refreshDrawer(false); })
          .then(function () {
            busy = false;
            /* Confettis a l'arrivee de la carte cadeau (meme moteur que le
               porte-monnaie). Le garde-fou de 10 s de lunelle-celebrate evite
               une double salve si la carte tombe juste apres le porte-monnaie. */
            if (window.lunelleCelebrate) window.lunelleCelebrate(document.querySelector('cart-drawer [data-lunelle-giftcard], [data-lunelle-giftcard]'));
          })
          .catch(function () { busy = false; });
      }
      if ((!cardWalletClaimed || cardQualifying < CARD_THRESHOLD) && cardKey && !busy) {
        busy = true;
        return post('cart/change.js', { id: cardKey, quantity: 0 })
          .then(function () { return refreshDrawer(false); })
          .then(function () { busy = false; })
          .catch(function () { busy = false; });
      }
      if (cardUnits > 1 && cardKey && !busy) {
        busy = true;
        return post('cart/change.js', { id: cardKey, quantity: 1 })
          .then(function () { return refreshDrawer(false); })
          .then(function () { busy = false; })
          .catch(function () { busy = false; });
      }

      paintCard(cardWalletClaimed, !!cardKey, cardQualifying, CARD_THRESHOLD);
    }).catch(function () {});
  }

  /* TOUJOURS passer par renderContents du theme : le carrousel Swiper des ventes
     croisees n'est reinitialise que sur ce chemin. */
  function refreshDrawer(open) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') {
      return refresh();
    }
    if (!open && drawerPending) return drawerPending;

    var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    var p = fetch(ROOT + '?sections=' + ids, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (open && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        drawer.renderContents({ sections: sections });
      })
      .then(refresh)
      .catch(function () { return refresh(); })
      .then(function (v) { if (drawerPending === p) drawerPending = null; return v; });

    if (!open) drawerPending = p;
    return p;
  }

  function handleAdd(add) {
    var picker = add.closest('[data-gift-picker]');
    var vid = picker && Number(picker.getAttribute('data-variant-id'));
    var err = picker && picker.querySelector('[data-gift-error]');
    if (!vid || add.classList.contains('is-loading')) return;
    add.classList.add('is-loading');
    if (err) err.hidden = true;

    post('cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _cadeau: 'oui' } }] })
      .then(function () {
        var panel = document.querySelector('[data-gtl-panel]');
        if (panel && !panel.hidden) {
          panel.hidden = true;
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
        return refreshDrawer(true);
      })
      .catch(function () { if (err) err.hidden = false; })
      .then(function () { add.classList.remove('is-loading'); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  }

  function act(t, e) {
    if (!t || !t.closest) return;
    var sw = t.closest('[data-gift-swatch]');
    if (sw) { e.preventDefault(); selectSwatch(sw); return; }
    var add = t.closest('[data-gift-add]');
    if (add) { e.preventDefault(); handleAdd(add); return; }
  }

  document.addEventListener('click', function (e) { act(e.target, e); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    act(e.target, e);
  });

  document.addEventListener('lunelle:bogo:claimed', schedule);

  window.addEventListener('resize', function () {
    if (resizeQueued) return;
    resizeQueued = true;
    requestAnimationFrame(function () { resizeQueued = false; hoist(); });
  });

  function observe() {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!drawer || drawer.__lunelleGiftObserved) return;
    drawer.__lunelleGiftObserved = true;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && t.closest('[data-lunelle-gift]')) continue;
        hoist();
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() { observe(); hoist(); refresh(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
